module.exports = __webpack_public_path__ + "static/media/search.2e5a42b6.svg";